<div class="search-bar-container dense-3">
    <mat-form-field [appearance]="appearance" subscriptSizing="dynamic" class="search-field dense-2 input-border-radius ">
        @if (label) {
            <mat-label>{{ label }}</mat-label>
        }
        <input
            matInput
            [formControl]="searchControl"
            [placeholder]="placeholder"
            (keyup.enter)="handleSearch()"
            (keypress)="allowOnlyDigits($event)"
            [attr.maxlength]="isPincodeInput ? 6 : null"
        />
        <button
            *ngIf="showClearButton && searchControl.value && suffixCloseIcon"
            mat-icon-button
            matSuffix
            (click)="handleClear()"
            aria-label="Clear"
        >
            <mat-icon>{{ suffixCloseIcon }}</mat-icon>
        </button>
        <mat-icon matPrefix *ngIf="prefixIcon">{{ prefixIcon }}</mat-icon>
        <span matSuffix *ngIf="suffixWord">{{ suffixWord }}</span>
        <button mat-icon-button matSuffix (click)="handleSearch()" *ngIf="suffixSearchIcon" aria-label="Search">
            <mat-icon>{{ suffixSearchIcon }}</mat-icon>
        </button>
    </mat-form-field>
</div>
